import { generateKey, GenerateConfig, GenerateFunction } from './common';

interface VueI18n {
  t: any;
  te: any;
}

export function generateTransifyVueI18n(i18n: VueI18n, config: GenerateConfig): GenerateFunction {
  if (!config || !config.project) {
    throw new Error('project is required!');
  }

  return function (label, namespace, options) {
    const computedKey = generateKey({ label, namespace, project: config.project });

    if (!computedKey) return '';

    // 这里使用te在生产环境下可能会有问题，比如带有{}等字符，无法正常检测
    // if (!i18n.te(computedKey)) {
    //   if (!config.isDev) return label; // key已经被转换，如果继续用i18n.t，会显示出转换后的key
    // }
    // 对于开发来说，不需要再关注key
    // 对于测试来说，希望暴露问题（这个时候就是工具的问题了）
    // 对于用户来说，显示key没有意义

    // 开发&生产过程中未录入的key，显示默认翻译：dev/live/staging/uat
    // 测试过程中未录入key，显示key：test
    // 抽象设计：是否显示未录入的key

    let res = i18n.t(computedKey, options);
    if (!config.isShowKey) {
      // te检测有问题，改为对翻译结果的检测
      // 如果返回的翻译结果和key相同，则说明未上传
      if (res === computedKey) {
        res = label;
      }
    }

    return res;
  };
}
